<template>
	<div class="bodyall">
		<div class="mainall">
			<div class="iconall">
				<div @click="forrouterPush('/Commoditymasterdata')">
					<img src="../../../../assets/img/home1.png" />
					<span>商品主数据</span>
				</div>
				<div @click="forrouterPush('Invoiceinventoryquery')">
					<img src="../../../../assets/img/home2.png" />
					<span>发票库存预警</span>
				</div>
				<div @click="forrouterPush('/Customermasterdata')">
					<img src="../../../../assets/img/home3.png" @click="routerPush('/')" />
					<span>客户主数据</span>
				</div>
			</div>
			<div class="heightdiv"><img src="../../../../assets/img/mainleft.png" /></div>
			<div class="iconall">
				<div @click="forrouterPush('/Entitysettings')">
					<img src="../../../../assets/img/home4.png" />
					<span>参数设置</span>
				</div>
				<div @click="forrouterPush('/Fillinandissuepositiveinvoice')">
					<img src="../../../../assets/img/home5.png" />
					<span>发票填开</span>
				</div>
				<div @click="forrouterPush('/Querystatistics')">
					<img src="../../../../assets/img/home6.png" />
					<span>发票修复</span>
				</div>
			</div>
			<div class="heightdiv"><img src="../../../../assets/img/mainright.png" /></div>
			<div class="iconall">
				<div @click="forrouterPush('/InvoiceQuery')">
					<img src="../../../../assets/img/home7.png" />
					<span>已开发票查询</span>
				</div>
				<div @click="forrouterPush('/Copytaxreturns')">
					<img src="../../../../assets/img/home8.png" />
					<span>汇总上传</span>
				</div>
				<div @click="forrouterPush('/SummaryReport')">
					<img src="../../../../assets/img/home9.png" />
					<span>发票资料查询统计</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},

	created() {
		// this.getDocList()
	},
	methods: {
		forrouterPush(url) {
			this.$router.push(url);
		}
	}
};
</script>

<style scoped="scoped" lang="less">
.iconall > div:extend(.Verticalcenter) {
	width: 123px;
	height: 123px;
	background: #ffffff;
	box-shadow: 0px 3px 16px rgba(34, 73, 229, 0.16);
	border-radius: 12px;
}
.iconall:extend(.distribution) {
	height: 100%;
}
.iconall > div {
	cursor: pointer;
}
.iconall > div > img {
	width: 48px;
	height: 48px;
}
.iconall > div > span {
	font-size: 12px;
	font-weight: 400;
	margin-top: 10px;
	color: #333333;
}
.bodyall {
	height: 100%;
}
.mainall:extend(.distribution-line) {
	height: 100%;
}
.heightdiv {
	height: 72vh;
}
.heightdiv > img {
	height: 100%;
}
</style>
